import clsx from "clsx";
import { Icon } from "../../../../components";
import {
  ISystemHealthDropdownItemProps,
  SystemHealthItemContentData
} from "../@types/systemhealth";
import SystemHealthItemContent from "./SystemHealthItemContent";

const SystemHealthDropdownItem = ({
  id,
  icon,
  title,
  content,
  isMetricHealthy = true
}: ISystemHealthDropdownItemProps) => {
  const isStringArray = (data: SystemHealthItemContentData): data is string[] =>
    typeof data[0] === "string";

  return (
    <div
      className={clsx(
        "system-health__dropdown-item",
        !isMetricHealthy && "system-health__dropdown-item--not-healthy"
      )}
      data-testid="system_health_dropdown_item"
    >
      <div className="system-health__dropdown-item-head">
        <Icon
          name={icon}
          className={clsx(
            "system-health__dropdown-item-icon",
            `system-health__dropdown-item-icon--${id}`
          )}
        />
        <div className="system-health__dropdown-item-title">{title}</div>
      </div>
      {isStringArray(content)
        ? content?.map((contentItem, idx) => (
            <SystemHealthItemContent key={idx}>
              {contentItem}
            </SystemHealthItemContent>
          ))
        : content?.map(({ label, value }, idx) => (
            <SystemHealthItemContent key={idx}>
              <span className="system-health__item-label">{label}</span> -{" "}
              {value}
            </SystemHealthItemContent>
          ))}
    </div>
  );
};

export default SystemHealthDropdownItem;
